import { selectProductInCartCode } from '@telialt/utils/src/eshopSelectors';

import { VARIANT_QUERY_PARAM } from '../constants';
import { useCartQuery } from './queries/useCartQuery';
import { useProductVariant } from './queries/useProductVariant';

export const useSelectedProductVariant = () => {
    const { cart } = useCartQuery();
    const productVariantCode = selectProductInCartCode(cart);

    const urlParams = new URLSearchParams(window.location.search);
    const variantInQuery = urlParams.get(VARIANT_QUERY_PARAM);

    const productVariantCodeParam =
        !variantInQuery || variantInQuery === productVariantCode ? productVariantCode : undefined;

    const { productVariant } = useProductVariant(productVariantCodeParam);

    return productVariant;
};
